<template>
    <section class="contenedor">
        <div class="pueba">

            <div class="kt-portlet__head-label" style="margin-top: 1rem;">
                <h3 class="kt-portlet__head-title text-center">
                    <b>Pago en línea</b>
                </h3>
                <h3 class="kt-portlet__head-title text-center">
                    <b>Mantenimientos prepagados</b>
                </h3>
                <h5 class="kt-portlet__head-title text-center">
                    Por favor ingresar con su usuario para continuar en el pago en linea
                </h5>
            </div>

            <form class="row" style="display: flex;justify-content: space-around; margin-left: 5%; margin-right: 5%;">

                <div class="col-lg-4">
                    <div class="col barra">
                        <div class="float-left der-icon" style="padding: 1rem;width: 100%">
                            <!-- <div class="kt-portlet__head-title"><b>{{ "Agencia: " }}</b>
                                {{ this.agencia.empresa + " " + this.agencia.nombre }}
                            </div>

                            <div class="kt-portlet__head-title"><b>{{ "Modelo: " }}</b>
                                {{ this.$store.getters.getVehiculo }}
                            </div>

                            <div class="kt-portlet__head-title"><b>{{ "Placa: " }}</b>
                                {{ this.$store.getters.getVehiculo }}
                            </div> -->

                            <img :src="validarUrl(this.$store.getters.getVehiculo) ? this.$store.getters.getVehiculo : sinImagen"
                                class="img-fluid animated zoomIn" draggable="false" />
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="kt-portlet__head-label" style="background-color: #e8e8e8;border-radius: 34px;">
                        <div style="margin-top: 1rem">
                            <labe class="titulo"><b>Login</b></labe>
                        </div>

                        <div class="margen">
                            <div class="form-group col-12">
                                <label for="númerodi">Número de identificación</label>
                                <input :disabled="procesando" type="tel" class="form-control form-control-sm"
                                    v-model="formulario.dt1" name="número de identificación" id="númerodi"
                                    v-validate="{ required: true }">
                                <span class="form-text text-danger">{{ errors.first("session.número de identificación")}}</span>
                            </div>
                            <div class="form-group col-12">
                                <label for="contraseña">Contraseña</label>
                                <div class="kt-input-icon kt-input-icon--right">
                                    <input :disabled="procesando" :type="mostrar ? 'text' : 'password'"
                                        class="form-control form-control-sm" v-model="formulario.dt2" name="contraseña"
                                        id="contraseña" v-validate="{ required: true }">
                                    <span class="kt-input-icon__icon kt-input-icon__icon--right"
                                        v-on:mousedown="mostrar = true" v-on:mouseup="mostrar = false"
                                        v-on:mouseleave="mostrar = false">
                                        <span><i class="la" :class="mostrar ? 'la-eye' : 'la-eye-slash'"></i></span>
                                    </span>
                                </div>
                                <span class="form-text text-danger">{{ errors.first("session.contraseña") }}</span>
                            </div>
                        </div>

                        <div style="margin-bottom: 1rem;display: flex;justify-content: space-around;">
                            <button type="submit" class="btn btn-primary btn-font-sm"
                                :class="procesando ? 'kt-spinner kt-spinner--right kt-spinner--lg kt-spinner--light disabled' : ''"
                                :disabled="procesando">
                                Iniciar sesión
                            </button>
                        </div>

                    </div>

                </div>

                 
                
                
           
            </form>



            <div class="pt-5 d-flex justify-content-between">
                

                







            </div>


        </div>


    </section>
</template>

<script>
import { isUrl } from "../../utils";


export default {
    name: "Login",
    data: () => ({
        formulario: {
            dt1: null,
            dt2: null,
        },
        vehiculo: {},
        agencia: {},
        sinImagen: require("@/assets/images/no-image.png"),
        procesando: false,
        modal: false,
        mostrar: false,
    }),

    

    methods: {
        validarUrl(url) {
            return isUrl(url)
        },
    }

}
</script>

<style>
.margen {
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 2.5rem;
}

.titulo {
    margin-left: 15%;
    font-family: kia;
    font-size: 15px;
}</style>
